<template>
  <CardComponent addClass="border-0 w-60">
    <div class="flex flex-col gap-1 items-center justify-center">
      <div class="text-sm font-medium text-gray-500">{{ title }}</div>
      <div class="text-base font-semibold text-gray-600" v-if="!loading">
        {{ total }}
      </div>
      <LoadingLoad v-if="loading" />
    </div>
  </CardComponent>
</template>
<script>
import CardComponent from "./CardComponent.vue";
import LoadingLoad from "./LoadingLoad.vue";

export default {
  components: {
    CardComponent,
    LoadingLoad,
  },
  props: {
    title: String,
    total: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style></style>
